module.exports = __webpack_public_path__ + "7801f915648051abc98046530eb25308.png";